import Api from './rest/TeamApi';

export default new Api();
